// src/api/adminApi.js
import apiClient from './apiClient';

// Fetch data from /admin endpoint with optional query parameters
export const fetchFeedbackData = async (params = {}) => {
  try {
    const response = await apiClient.get('lifewink/admin/feedback', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching admin data:', error);
    throw error;
  }
};

export const updateEmailSubscriptionStatus = async (params = {}) => {
  try {
    const response = await apiClient.get('/lifewink/subscription', { params });
    return response.data;
  } catch (error) {
    console.error('Error updating subscription status:', error);
    throw error;
  }
};

export const submitSupportRequest = async (body = {}) => {
  try {
    const response = await apiClient.post('/support', body);
    return response.data;
  } catch (error) {
    console.error('Error submitting support request:', error);
    throw error;
  }
};

export const submitAccountDeletionRequest = async (body = {}) => {
  try {
    // Add a type field to identify this as an account deletion request
    const requestData = {
      ...body,
      requestType: 'ACCOUNT_DELETION'
    };
    const response = await apiClient.post('/lifewink/deleteUser', requestData);
    return response.data;
  } catch (error) {
    console.error('Error submitting account deletion request:', error);
    throw error;
  }
};
